import React from "react";
import AdminProcessedBatch from "./admin-processed-batch";

export const AdminProcessedBatchRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "processed-batch",
      element: <AdminProcessedBatch />,
    },
  ],
};
